export const getRoomSelectorConfigurationByProjectId = async (
  baseUri: string,
  projectId: string,
) => {
  const response = await fetch(`${baseUri}/findByProjectId/${projectId}`);
  if (!response.ok) {
    throw new Error("error fetching room selector configuration");
  }
  const parsedResponse = await response.json();
  return parsedResponse;
};
